import { IBirthDate } from '~exported/loyalty-birthday/ILoyaltyBirthday';

export const SetUserBirthdate = (birthday: IBirthDate) => {
    const { month, day, year } = birthday;

    const yearParam = year ? `birthdayYear: ${year},` : '';

    const setUserBirthdateQuery = `
        mutation  {
            setBirthdate (
                birthdayDay: ${day}
                birthdayMonth: ${month}
                ${yearParam}
            )
            {
                id
                success
                errorDetail
            }
        }
    `;

    return setUserBirthdateQuery;
};
